export enum ClaimsValueEnum {
  SuperUser = 'super',
}
